import * as React from "react"

export interface IHeaderWithBannerProps {
    bannerImage: string
}

const HeaderWithBanner: React.FC<IHeaderWithBannerProps> = (props) => {
    const { bannerImage } = props

    return <div className="header">
        {/* this is a dummy image; replace with actual image */}
        <img src={`images/${bannerImage}`} alt="" style={{ width: "100%", height: "100%" }} />
    </div>
}

export default HeaderWithBanner